window.onscroll = function () {
    showHideMenuBackground()
    setStartPosition()
    parallaxFunction()
}

let debug = false

let isMobile = window.matchMedia("only screen and (max-width: 575px)");
let isTablet = window.matchMedia("only screen and (min-width: 576px) and (max-width: 991px)");

let parallaxPhones = document.getElementById('hot-brand')
let phoneBlack = document.getElementById('phone-black')
let phoneWhite = document.getElementById('phone-white')
let previousPosition = 0
let startPosBlack = 400
let startPosWhite = 0
let posBlack = startPosBlack
let posWhite = startPosWhite

//if (isTablet.matches) {}
let initStartPos = false
function setStartPosition(){
    if(initStartPos === false) {
        if (debug) {
            console.log("set start position")
        }
        if (isMobile.matches) {
            if (debug) {
                console.log("is mobile")
            }
            startPosBlack = 300
            startPosWhite = 100
        } else if (isTablet.matches) {
            if (debug) {
                console.log("is tablet")
            }
            startPosBlack = 300
            startPosWhite = 100
        }
        setInitState()
    }
    initStartPos = true
}

function setInitState() {
    posBlack = startPosBlack
    posWhite = startPosWhite
}

function showHideMenuBackground() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    document.getElementById("nav").classList.add('nav-bg')
  } else {
    document.getElementById("nav").classList.remove('nav-bg')
  }
}

function parallaxFunction() {
    if (parallaxPhones != null) {

        let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight // height of the visible window

        let elementTop = parallaxPhones.offsetTop // position start of element
        let elementBottom = elementTop + parallaxPhones.offsetHeight // position end of element

        let viewportTop = document.body.scrollTop || document.documentElement.scrollTop // position from top
        let viewportBottom = viewportTop + windowHeight // postion from top plus window height

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
            //console.log("object in view")
            if(previousPosition < viewportTop) {
                // user is scrolling down
                //console.log("user is scrolling down " + previousPosition + " vs " + viewportTop)
                if (posWhite > startPosBlack || posBlack < startPosWhite) {
                    if (debug) {
                        console.log("out of range down")
                    }
                    /*console.log("set init from down")
                    setTimeout(function () {
                        setInitState()
                    }, 2000);*/
                } else {
                    if (isMobile.matches) {
                        posBlack -= 1
                        posWhite += 1
                    } else if (isTablet.matches) {
                        posBlack -= 1
                        posWhite += 1
                    } else {
                        posBlack -= 2
                        posWhite += 2
                    }
                }
                if (debug) {
                    console.log("set pos from scroll down > pos black: " + posBlack + " pos white " + posWhite)
                }
                phoneBlack.style.top = "-" + posBlack + "px"
                phoneWhite.style.top = "-" + posWhite + "px"
            } else {
                // user is scrolling up
                //console.log("user is scrolling up " + previousPosition + " vs " + viewportTop)
                if (posWhite < startPosWhite || posBlack > startPosBlack) {
                    if (debug) {
                        console.log("out of range up")
                    }
                    /*console.log("set init from up")
                    setTimeout(function () {
                        setInitState()
                    }, 2000);*/
                } else {
                    if (isMobile.matches) {
                        posBlack += 1
                        posWhite -= 1
                    } else if (isTablet.matches) {
                        posBlack += 1
                        posWhite -= 1
                    } else {
                        posBlack += 2
                        posWhite -= 2
                    }
                }
                if (debug) {
                    console.log("set pos from scroll up > pos black: " + posBlack + " pos white " + posWhite)
                }
                phoneBlack.style.top = "-" + posBlack + "px"
                phoneWhite.style.top = "-" + posWhite + "px"
            }
            previousPosition = viewportTop
        } else {
            /*setInitState()
            if((elementBottom - 100) < viewportTop && (elementTop -100) > viewportBottom) {
                phoneBlack.style.top = "-" + posBlack + "px"
                phoneWhite.style.top = posWhite + "px"
            }*/
        }
        /*
        console.log("windowHeight " + windowHeight)
        console.log("elementTop " + elementTop)
        console.log("elementBottom" + elementBottom)
        console.log("viewportTop" + viewportTop)
        console.log("viewportTop" + viewportTop)
        console.log("viewportBottom" + viewportBottom)
        console.log("elementTop: " + elementTop + " elementBottom: " + elementBottom)
        */
    }
}
